function createInputField (name, value) {
  const input = document.createElement('input');
  input.type = 'text';
  input.name = name;
  input.value = value;

  return input;
}

const appendFields = (form, fields, parentName = null) => {
  for (const [name, value] of Object.entries(fields)) {
    if (value) {
      const fieldName = parentName ? `${parentName}[${name}]` : name;
      if (typeof value === 'object') {
        appendFields(form, value, fieldName);
      } else {
        form.appendChild(createInputField(fieldName, value));
      }
    }
  }
};

export function nativeFormSubmit (url, fields, method = 'POST') {
  if (!url) {
    throw new Error('Required form url is missing');
  }

  const form = document.createElement('form');
  form.action = url;
  form.method = method;

  appendFields(form, fields);

  const submitBtnElm = document.createElement('button');
  submitBtnElm.type = 'submit';

  form.appendChild(submitBtnElm);
  document.body.appendChild(form);
  form.style.display = 'none';
  form.submit();
  document.body.removeChild(form);
}
